export const BASE_CLASS = 'mt-ListRatings'
export const NO_OP = () => {}
